const getSupportSection = (): CookieConsent.Section => ({
    title: 'Více informací',
    description: `V případě dotazů týkajících se cookies nás, prosím, <a class="cc-link" href="${process.env.NEXT_PUBLIC_SUPPORT_NEW_TICKET_URL}" target="_blank" rel="noreferrer">kontaktujte</a>.`,
});

export const getCookieConsentConfig = (adsMeasurementEnabled: boolean): CookieConsent.CookieConsentConfig => {
    if (!adsMeasurementEnabled) {
        return {
            autoClearCookies: true,
            mode: 'opt-in',
            guiOptions: {
                consentModal: {
                    layout: 'cloud',
                    position: 'bottom center',
                    flipButtons: false,
                },
                preferencesModal: {
                    layout: 'box',
                    position: 'right',
                    equalWeightButtons: true,
                    flipButtons: false,
                },
            },
            categories: {
                necessary: {
                    readOnly: true,
                },
                analytics: {},
            },
            language: {
                default: 'cs',
                autoDetect: 'browser',
                translations: {
                    cs: {
                        consentModal: {
                            title: 'Používáme cookies',
                            description:
                                'Soubory cookie používáme k analýze údajů o našich návštěvnících, ke zlepšení našich webových stránek, zobrazení personalizovaného obsahu a k tomu, abychom vám poskytli skvělý zážitek z webu.',
                            acceptAllBtn: 'Přijmout všechny',
                            acceptNecessaryBtn: 'Odmítnout všechny',
                            showPreferencesBtn: 'Podrobné nastavení',
                        },
                        preferencesModal: {
                            title: 'Podrobné nastavení',
                            acceptAllBtn: 'Přijmout všechny',
                            acceptNecessaryBtn: 'Odmítnout všechny',
                            savePreferencesBtn: 'Uložit podrobné nastavení',
                            closeIconLabel: 'Zavřít nastavení',
                            serviceCounterLabel: 'Service|Services',
                            sections: [
                                {
                                    title: 'Cookie Usage',
                                    description:
                                        'Soubory cookie používáme k analýze údajů o našich návštěvnících, ke zlepšení našich webových stránek, zobrazení personalizovaného obsahu a k tomu, abychom vám poskytli skvělý zážitek z webu.',
                                },
                                {
                                    title: 'Technický provoz stránek',
                                    linkedCategory: 'necessary',
                                },
                                {
                                    title: 'Personalizovaná reklama a obsah, měření reklamy a obsahu, poznatky o okruzích publika a vývoj produktů',
                                    linkedCategory: 'analytics',
                                },
                                getSupportSection(),
                            ],
                        },
                    },
                },
            },
        };
    }

    return {
        revision: 2,
        autoClearCookies: true,
        mode: 'opt-in',
        cookie: {
            sameSite: 'Lax',
            secure: process.env.NODE_ENV === 'production',
        },
        guiOptions: {
            consentModal: {
                layout: 'cloud',
                position: 'bottom center',
                flipButtons: false,
            },
            preferencesModal: {
                layout: 'box',
                position: 'right',
                equalWeightButtons: true,
                flipButtons: false,
            },
        },
        categories: {
            necessary: {
                readOnly: true,
            },
            analytics: {},
            advertising: {},
        },
        language: {
            default: 'cs',
            autoDetect: 'browser',
            translations: {
                cs: {
                    consentModal: {
                        title: 'Používáme cookies',
                        description:
                            'Soubory cookie používáme k technickému provozu, analýze návštěvnosti a měření reklamy podle vašeho nastavení.',
                        acceptAllBtn: 'Přijmout všechny',
                        acceptNecessaryBtn: 'Odmítnout všechny',
                        showPreferencesBtn: 'Podrobné nastavení',
                    },
                    preferencesModal: {
                        title: 'Podrobné nastavení',
                        acceptAllBtn: 'Přijmout všechny',
                        acceptNecessaryBtn: 'Odmítnout všechny',
                        savePreferencesBtn: 'Uložit podrobné nastavení',
                        closeIconLabel: 'Zavřít nastavení',
                        serviceCounterLabel: 'Service|Services',
                        sections: [
                            {
                                title: 'Používání cookies',
                                description:
                                    'Technické cookies zajišťují provoz webu. Analytické cookies a cookies pro měření reklamy používáme jen podle vaší volby.',
                            },
                            {
                                title: 'Technický provoz stránek',
                                linkedCategory: 'necessary',
                            },
                            {
                                title: 'Analytické cookies',
                                linkedCategory: 'analytics',
                            },
                            {
                                title: 'Měření reklamy',
                                description:
                                    'Pomáhá nám vyhodnotit, zda reklama vedla k registraci nebo nákupu. Reklamní personalizaci nepovolujeme.',
                                linkedCategory: 'advertising',
                            },
                            getSupportSection(),
                        ],
                    },
                },
            },
        },
    };
};

export const cookies = getCookieConsentConfig(process.env.NEXT_PUBLIC_ADS_CONVERSIONS_ENABLED === 'true');
